module.exports = __webpack_public_path__ + "static/Confluent-cb542807edec54fb905f1ebc916a0da8.jpg";